// Author Lin
// Date 2021-07-06 16:18:56

class SithMesInventoryWmStock {
constructor({
        id = null,
        material = '',
        plant = '',
        storageLocation = '',
        batch = '',
        specialStock = '',
        specialStockNumber = '',
        materialDescription = '',
        storageType = '',
        storageBin = '',
        availableStock = '',
        baseUnit = '',
        grDate = '',
        totalStock = '',
        grNumber = '',
        weight = '',
        trNumber = '',
        weightUnit = '',
        tpNumber = '',
        remark = ''}
= {}) {
    this.id = id;
    this.material = material;
    this.plant = plant;
    this.storageLocation = storageLocation;
    this.batch = batch;
    this.specialStock = specialStock;
    this.specialStockNumber = specialStockNumber;
    this.materialDescription = materialDescription;
    this.storageType = storageType;
    this.storageBin = storageBin;
    this.availableStock = availableStock;
    this.baseUnit = baseUnit;
    this.grDate = grDate;
    this.totalStock = totalStock;
    this.grNumber = grNumber;
    this.weight = weight;
    this.trNumber = trNumber;
    this.weightUnit = weightUnit;
    this.tpNumber = tpNumber;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryWmStock();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'material',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.material',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.plant',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'storageLocation',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.storageLocation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'batch',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.batch',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'specialStock',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.specialStock',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'specialStockNumber',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.specialStockNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialDescription',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.materialDescription',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.storageType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'storageBin',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.storageBin',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'availableStock',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.availableStock',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'baseUnit',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.baseUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'grDate',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.grDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'totalStock',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.totalStock',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'grNumber',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.grNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.weight',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'trNumber',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.trNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'weightUnit',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.weightUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tpNumber',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.tpNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryWmStock.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    materialFilter : "",
    plantFilter : "",
    storageLocationFilter : "",
    batchFilter : "",
    specialStockFilter : "",
    specialStockNumberFilter : "",
    materialDescriptionFilter : "",
    storageTypeFilter : "",
    storageBinFilter : "",
    availableStockFilter : "",
    baseUnitFilter : "",
    grDateRteFilter : "",
    grDateLteFilter : "",
    totalStockFilter : "",
    grNumberFilter : "",
    weightFilter : "",
    trNumberFilter : "",
    weightUnitFilter : "",
    tpNumberFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'materialFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.material',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'plantFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.plant',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageLocationFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.storageLocation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'batchFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.batch',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specialStockFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.specialStock',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specialStockNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.specialStockNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'materialDescriptionFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.materialDescription',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.storageType',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageBinFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.storageBin',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'availableStockFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.availableStock',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'baseUnitFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.baseUnit',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'grDateRteFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.grDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'grDateLteFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.grDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'totalStockFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.totalStock',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'grNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.grNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'weightFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.weight',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'trNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.trNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'weightUnitFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.weightUnit',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tpNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryWmStock.filter.tpNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'material',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.material',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.plant',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageLocation',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.storageLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'batch',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.batch',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specialStock',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.specialStock',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specialStockNumber',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.specialStockNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'materialDescription',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.materialDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.storageType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageBin',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.storageBin',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'availableStock',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.availableStock',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'baseUnit',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.baseUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'grDate',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.grDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'totalStock',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.totalStock',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'grNumber',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.grNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.weight',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'trNumber',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.trNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'weightUnit',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.weightUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tpNumber',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.tpNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryWmStock.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesInventoryWmStock, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
